import Model, { ID } from 'src/models/model'

export default class SignageMediaClass extends Model {
  static name = 'SignageMediaClass'

  static isConfiguration = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.SiteContent]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null

      },
      description: {
        type: String,
        default: null

      }
    }
    this.paginate = true
  }
}
